module.exports = __webpack_public_path__ + "img/u161.723ada4.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/figma/u161.png
// module id = sPYV
// module chunks = 0